__webpack_require__.p = "https://xoq.app/lcc/";